import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';

export default function PrivacyPolicy() {
    const navigate = useNavigate();

    return (
        <div className="bg-light min-vh-100 py-5">
            <div className="container py-5" style={{ maxWidth: '820px' }}>

                {/* Back button */}
                <button
                    className="btn btn-sm btn-outline-secondary rounded-pill px-3 mb-5 d-inline-flex align-items-center gap-2"
                    onClick={() => navigate(-1)}
                >
                    <FontAwesomeIcon icon={faArrowLeft} /> Wróć
                </button>

                <h1 className="display-5 fw-bold mb-2">Polityka Prywatności</h1>
                <p className="text-secondary mb-5">Ostatnia aktualizacja: 25 lutego 2025 r.</p>

                <div className="d-flex flex-column gap-5">

                    <section>
                        <h2 className="h5 fw-bold mb-3">1. Administrator danych osobowych</h2>
                        <p className="text-secondary">
                            Administratorem danych osobowych zbieranych za pośrednictwem aplikacji webowej <strong>SayQ</strong>
                            (dostępnej pod adresem <strong>queroapp.pl</strong>) jest <strong>Mateusz Krosnowski</strong>,
                            prowadzący działalność pod marką SayQ App.<br /><br />
                            Kontakt: <a href="mailto:kontakt@queroapp.pl" className="text-primary">kontakt@queroapp.pl</a>
                        </p>
                    </section>

                    <section>
                        <h2 className="h5 fw-bold mb-3">2. Jakie dane zbieramy</h2>
                        <p className="text-secondary mb-3">W zależności od sposobu korzystania z aplikacji przetwarzamy następujące dane:</p>
                        <ul className="text-secondary d-flex flex-column gap-2">
                            <li><strong>Dane rejestracyjne organisatora:</strong> adres e-mail, imię i nazwisko, hasło (przechowywane w postaci zaszyfrowanej).</li>
                            <li><strong>Dane dotyczące wydarzeń:</strong> nazwa, opis, logo wydarzenia — wprowadzone przez organizatora.</li>
                            <li><strong>Dane uczestników:</strong> SayQ nie wymaga od uczestników rejestracji. Do sesji używany jest anonimowy token sesji. Opcjonalnie uczestnik może podać swoje imię przy zadawaniu pytania.</li>
                            <li><strong>Pytania i głosy:</strong> treść pytań zadanych przez uczestników oraz wyniki ankiet.</li>
                            <li><strong>Dane techniczne:</strong> adres IP, typ przeglądarki, logi systemowe — w celach bezpieczeństwa i diagnostycznych.</li>
                            <li><strong>Pliki cookie:</strong> szczegóły opisano w sekcji 6.</li>
                        </ul>
                    </section>

                    <section>
                        <h2 className="h5 fw-bold mb-3">3. Podstawa prawna i cel przetwarzania</h2>
                        <div className="table-responsive">
                            <table className="table table-bordered text-secondary small">
                                <thead className="table-light">
                                    <tr>
                                        <th>Cel przetwarzania</th>
                                        <th>Podstawa prawna (RODO)</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>Świadczenie usług (rejestracja, zarządzanie kontem)</td>
                                        <td>Art. 6 ust. 1 lit. b – wykonanie umowy</td>
                                    </tr>
                                    <tr>
                                        <td>Obsługa wydarzeń i sesji Q&amp;A</td>
                                        <td>Art. 6 ust. 1 lit. b – wykonanie umowy</td>
                                    </tr>
                                    <tr>
                                        <td>Analiza ruchu, poprawa działania serwisu</td>
                                        <td>Art. 6 ust. 1 lit. f – prawnie uzasadniony interes</td>
                                    </tr>
                                    <tr>
                                        <td>Pliki cookie analityczne</td>
                                        <td>Art. 6 ust. 1 lit. a – zgoda użytkownika</td>
                                    </tr>
                                    <tr>
                                        <td>Bezpieczeństwo systemu i zapobieganie nadużyciom</td>
                                        <td>Art. 6 ust. 1 lit. f – prawnie uzasadniony interes</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </section>

                    <section>
                        <h2 className="h5 fw-bold mb-3">4. Okres przechowywania danych</h2>
                        <ul className="text-secondary d-flex flex-column gap-2">
                            <li>Dane konta organizatora: do momentu usunięcia konta lub przez 3 lata od ostatniego logowania.</li>
                            <li>Dane wydarzeń i pytań: przez czas trwania konta, następnie usuwane w ciągu 90 dni.</li>
                            <li>Logi techniczne: maksymalnie 12 miesięcy.</li>
                            <li>Dane niezbędne do rozliczenia: przez wymagany prawem okres (5 lat od końca roku podatkowego).</li>
                        </ul>
                    </section>

                    <section>
                        <h2 className="h5 fw-bold mb-3">5. Twoje prawa</h2>
                        <p className="text-secondary mb-3">Przysługują Ci następujące prawa wynikające z RODO:</p>
                        <ul className="text-secondary d-flex flex-column gap-2">
                            <li><strong>Prawo dostępu</strong> do swoich danych osobowych.</li>
                            <li><strong>Prawo do sprostowania</strong> danych nieprawidłowych lub niekompletnych.</li>
                            <li><strong>Prawo do usunięcia</strong> danych („prawo do bycia zapomnianym").</li>
                            <li><strong>Prawo do ograniczenia przetwarzania</strong> w określonych przypadkach.</li>
                            <li><strong>Prawo do przenoszenia danych</strong> w ustrukturyzowanym formacie.</li>
                            <li><strong>Prawo do sprzeciwu</strong> wobec przetwarzania opartego na prawnie uzasadnionym interesie.</li>
                            <li><strong>Prawo do cofnięcia zgody</strong> na przetwarzanie danych opartych na zgodzie (bez wpływu na zgodność z prawem wcześniejszego przetwarzania).</li>
                            <li><strong>Prawo do skargi</strong> do organu nadzorczego — Prezesa Urzędu Ochrony Danych Osobowych (PUODO), ul. Stawki 2, 00-193 Warszawa.</li>
                        </ul>
                        <p className="text-secondary mt-3">
                            Aby skorzystać z powyższych praw, skontaktuj się z nami pod adresem:{' '}
                            <a href="mailto:kontakt@queroapp.pl" className="text-primary">kontakt@queroapp.pl</a>
                        </p>
                    </section>

                    <section>
                        <h2 className="h5 fw-bold mb-3">6. Pliki cookie</h2>
                        <p className="text-secondary mb-3">
                            Aplikacja SayQ używa plików cookie w następujących celach:
                        </p>
                        <ul className="text-secondary d-flex flex-column gap-2">
                            <li><strong>Cookie niezbędne (sesyjne):</strong> umożliwiają prawidłowe działanie aplikacji i uwierzytelnianie. Są wymagane do korzystania z serwisu i nie wymagają zgody.</li>
                            <li><strong>Cookie analityczne:</strong> służą do zbierania anonimowych statystyk dotyczących korzystania ze strony (np. liczba odwiedzin, popularne podstrony). Wymagają Twojej zgody.</li>
                        </ul>
                        <p className="text-secondary mt-3">
                            Możesz zarządzać plikami cookie w ustawieniach przeglądarki lub poprzez panel zgody dostępny przy pierwszym wejściu na stronę.
                        </p>
                    </section>

                    <section>
                        <h2 className="h5 fw-bold mb-3">7. Przekazywanie danych podmiotom trzecim</h2>
                        <p className="text-secondary">
                            Twoje dane mogą być przekazywane podmiotom wspierającym działanie usługi, w szczególności:
                        </p>
                        <ul className="text-secondary d-flex flex-column gap-2 mt-2">
                            <li><strong>Google Firebase</strong> – usługi uwierzytelniania i bazy danych (Stany Zjednoczone, na podstawie standardowych klauzul umownych).</li>
                            <li><strong>Dostawca hostingu</strong> – serwer zlokalizowany w UE.</li>
                        </ul>
                        <p className="text-secondary mt-3">
                            Nie sprzedajemy ani nie udostępniamy danych osobom trzecim w celach marketingowych.
                        </p>
                    </section>

                    <section>
                        <h2 className="h5 fw-bold mb-3">8. Bezpieczeństwo danych</h2>
                        <p className="text-secondary">
                            Stosujemy techniczne i organizacyjne środki bezpieczeństwa adekwatne do ryzyka, w tym szyfrowanie połączeń (HTTPS/TLS),
                            haszowanie haseł oraz ograniczanie dostępu do danych osobowych.
                        </p>
                    </section>

                    <section>
                        <h2 className="h5 fw-bold mb-3">9. Zmiany polityki prywatności</h2>
                        <p className="text-secondary">
                            Zastrzegamy sobie prawo do zmiany niniejszej Polityki Prywatności. O istotnych zmianach poinformujemy za pośrednictwem
                            poczty e-mail lub komunikatu na stronie aplikacji. Data ostatniej aktualizacji jest widoczna na górze dokumentu.
                        </p>
                    </section>

                    <section>
                        <h2 className="h5 fw-bold mb-3">10. Kontakt</h2>
                        <p className="text-secondary">
                            W sprawach dotyczących ochrony danych osobowych prosimy o kontakt:<br />
                            📧 <a href="mailto:kontakt@queroapp.pl" className="text-primary">kontakt@queroapp.pl</a><br />
                            🌐 <a href="https://queroapp.pl" className="text-primary" target="_blank" rel="noopener noreferrer">queroapp.pl</a>
                        </p>
                    </section>

                </div>
            </div>
        </div>
    );
}
